import { render, staticRenderFns } from "./NavigationSingleColumn.vue?vue&type=template&id=39b88f76"
import script from "./NavigationSingleColumn.vue?vue&type=script&lang=js"
export * from "./NavigationSingleColumn.vue?vue&type=script&lang=js"
import style0 from "./NavigationSingleColumn.vue?vue&type=style&index=0&id=39b88f76&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports